import { API } from "../store"
import { updateUserCompany } from "./authentication"
import handleCatch from "../lib/catch"

export const toggleEditCompanyDialog = (
  editCompanyDialogOpen = false,
  editCompany
) => ({
  type: "COMPANIES::TOGGLE_EDIT_DIALOG",
  editCompanyDialogOpen,
  editCompany,
})

export const toggleCreateCompanyDialog = (createCompanyDialogOpen = false) => ({
  type: "COMPANIES::TOGGLE_CREATE_DIALOG",
  createCompanyDialogOpen,
})

export const toggleBookingDialog = (
  bookingDialogOpen = false,
  bookingUser = {},
  position
) => ({
  type: "COMPANIES::TOGGLE_BOOKING_DIALOG",
  bookingDialogOpen,
  bookingUser,
  position,
})

export const toggleSuggestPositionDialog = (
  suggestPositionDialogOpen = false
) => ({
  type: "COMPANIES::TOGGLE_SUGGEST_POSITION_DIALOG",
  suggestPositionDialogOpen,
})

export const toggleMessageDialog = (
  messageDialogOpen = false,
  messageUser = {},
  position
) => ({
  type: "COMPANIES::TOGGLE_MESSAGE_DIALOG",
  messageDialogOpen,
  messageUser,
  position,
})

export const companyUpdated = (company = {}) => ({
  type: "COMPANIES::COMPANY_UPDATED",
  company,
})

export const setShootfields = (companyShootFields = []) => ({
  type: "COMPANIES::SET_COMPANY_SHOOT_FIELDS",
  companyShootFields: companyShootFields,
})

export const _updateCompany = updates => {
  return dispatch => {
    dispatch(companyUpdated(updates))
    dispatch(updateUserCompany(updates))
  }
}

export const switchActiveCompany = (companyId, accessLevel) => ({
  type: "COMPANIES::SWITCH_ACTIVE_COMPANY",
  companyId,
  accessLevel,
})

export const createCompany = data => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.post(`/companies`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "company created") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const updateCompany = (companyId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.post(`/companies/${companyId}`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "company updated") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const addManager = (companyId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.post(`/companies/${companyId}/user/${userId}`)
          .send({
            access_level: 1,
          })
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (
              response.message === "user added to company" ||
              response.message === "updated company user"
            ) {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const removeManager = (companyId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.post(`/companies/${companyId}/user/${userId}`)
          .send({
            access_level: 2,
          })
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "user removed as manager") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const addUserToCompany = (companyId, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.post(`/companies/${companyId}/user/${userId}`)
          .send({
            access_level: 2,
          })
          .then(response => {
            if (!response.ok) {
              //reject((response.body) ? response.body : response);
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (
              response.message === "user added to company" ||
              response.message === "updated company user" ||
              response.message === "user removed as manager"
            ) {
              resolve(response)
            } else {
              reject(response)
            }
          })
          .catch(error => {
            reject(error)
          })
      call()
    })
    return deferred
  }
}

export const createBooking = (booking, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.post(`/generic/booking/user/${userId}`)
          .send(booking)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "booking created") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const sendBooking = bookingId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.get(`/mailer/booking/${bookingId}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "Email sent") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const createMessage = (message, userId) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.post(`/generic/message/user/${userId}`)
          .send(message)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "Message created") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const sendMessage = messageId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.get(`/mailer/message/${messageId}`)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "Email sent") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}

export const suggestRole = data => dispatch => {
  return new Promise((resolve, reject) => {
    API.post(`/companies/roles/suggest`)
      .send(data)
      .then(response => {
        if (!response.ok) {
          throw Error(response.statusText)
        }

        return response
      })
      .then(response => response.body)
      .then(response => {
        if (response.message === "Role suggested") {
          resolve(response)
        } else {
          reject(response)
        }
      })
  })
}

export const getCompanyShootFields = companyId => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = API.get(`/companies/${companyId}/shoot_fields`)
        .then(response => response.body)
        .then(response => {
          if (response.message === "Company found") {
            dispatch(setShootfields(response.result))
          } else {
            resolve([])
          }
        })
        .catch(err => {
          handleCatch(err, dispatch)
            .then(call)
            .catch(reject)
        })
    })
    return deferred
  }
}

export const saveCompanyShootField = (companyId, data) => {
  return dispatch => {
    const deferred = new Promise((resolve, reject) => {
      const call = () =>
        API.post(`/companies/${companyId}/shootfields`)
          .send(data)
          .then(response => {
            if (!response.ok) {
              throw Error(response.statusText)
            }

            return response
          })
          .then(response => response.body)
          .then(response => {
            if (response.message === "Field added") {
              resolve(response)
            } else {
              reject(response)
            }
          })
      call()
    })
    return deferred
  }
}
